/**
 * Phase 107 (Plan 107-10 / D-16) — reset-grid confirmation.
 *
 * Mirrors `RevokeConfirmModal.tsx`'s title/body/footer structure via the
 * shared `Modal` shell (same precedent `DeleteBandConfirmModal.tsx` and
 * `DeleteConfigConfirmModal.tsx` already set), with **no** re-typed
 * confirmation-word input — D-16 names Reset a first-class control, and it
 * is a far more frequent, lower-stakes action than an offboarding access
 * revoke. The body states what the operation actually does: bands survive,
 * only their assignments to hours are cleared.
 */
import { Modal } from '../common/Modal';
import { Button } from '../common/Button';

export interface ResetGridConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  configurationName: string;
  isLoading?: boolean;
}

export function ResetGridConfirmModal({
  isOpen,
  onClose,
  onConfirm,
  configurationName,
  isLoading = false,
}: ResetGridConfirmModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Reset grid?"
      ariaLabelledBy="reset-grid-modal-title"
      size="sm"
      footer={
        <div className="flex justify-end gap-3">
          <Button variant="secondary" onClick={onClose} disabled={isLoading}>
            Cancel
          </Button>
          <Button variant="danger" onClick={onConfirm} isLoading={isLoading}>
            Reset grid
          </Button>
        </div>
      }
    >
      <p className="text-gray-600">
        {`This clears every painted hour in "${configurationName}". Bands stay — only their assignments to hours are gone.`}
      </p>
    </Modal>
  );
}

export default ResetGridConfirmModal;
